import { Form } from '@sravni/cosago-react-library/lib/components';
import cn from 'classnames';
import type { FC } from 'react';
import React from 'react';

import styles from './AnketaFormPopup.module.scss';

interface IAnketaFormPopup extends IFormPopup {
  isOpen: boolean;
  title?: string | JSX.Element;
  FormElement: FC<IFormPopup>;
  subtitle?: string | JSX.Element;
  icon?: React.ReactNode;
  isClosable: boolean;
  stepIndex: number;
  iconSize?: 36 | 48;
}

export const AnketaFormPopup: FC<IAnketaFormPopup> = (props) => {
  const {
    isOpen,
    onClose,
    title = 'Проверьте данные',
    FormElement,
    isFormForceOpened,
    onFormSubmit,
    setHeader,
    subtitle,
    icon,
    isLoading,
    isClosable,
    children,
    stepIndex,
    submitButtonText,
    iconSize = 36,
    analyticsOverrides,
  } = props;
  return (
    <Form.EditPopup
      title={title as unknown as string}
      subtitle={(<div className={styles.popupSubtitleContainer}>{subtitle}</div>) as unknown as string}
      icon={icon}
      onPopupClose={() => onClose?.(false)}
      isClosable={isClosable}
      className={cn('h-preline', styles.popup, { [styles.popupWithBigIcon]: iconSize === 48 })}
      isVisible={isOpen}
    >
      {children}
      <FormElement
        isFormForceOpened={isFormForceOpened}
        onFormSubmit={onFormSubmit}
        onClose={onClose}
        isDialog
        isLoading={isLoading}
        setHeader={setHeader}
        stepIndex={stepIndex}
        submitButtonText={submitButtonText}
        analyticsOverrides={analyticsOverrides}
      />
    </Form.EditPopup>
  );
};
